import { api } from "../api";
import { CareTemplate } from "../../model/templates/CareTemplate";
import { fromCareTemplateToGenerated, parseCareTemplate } from "../../parsers/template/parseCareTemplate";

export const postCareTemplate = async (careTemplate: CareTemplate) => {
  const result = await api.services.careTemplates.createCareTemplate(fromCareTemplateToGenerated(careTemplate));
  return parseCareTemplate(result.data);
};
